import { useTranslation } from 'react-i18next'

const LivingRoom2 = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="livingroom2-title"
      {...props}
    >
      <title id="livingroom2-title">{t('antagonists:drunkparent:components:background')}</title>
      <defs>
        <clipPath id="livingroom2-a">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="livingroom2-b">
          <path
            d="M228.57 147.4c58.5 1.45 107.19 35.84 109.32 113.64 2.03 74.04-55.21 120.87-107.88 119.87-56.4-1.07-110.37-49.3-110.28-118.91.1-70.5 52.81-115.99 108.84-114.6Z"
            style={{
              fill: '#eee6f1',
            }}
          />
        </clipPath>
      </defs>
      <g
        style={{
          clipPath: 'url(#livingroom2-a)',
        }}
      >
        <path
          style={{
            fill: '#fbdedc',
          }}
          d="M-213.38-164.57h2280.04v1270.99H-213.38z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#a2c08f',
          }}
          d="M-334.14 736.22h2400.45v867.77H-334.14z"
        />
        <path
          d="m727.64 825.02-8.43 86.71-20.59-1.25-1.61-75.78s33.86-8.06 30.63-9.67Z"
          style={{
            fill: '#54535e',
          }}
        />
        <path
          d="M-108.85 507.96c-17.37.38-33.97-1.18-59.65 15.94-22.95 15.3-27.27 45.11-15.81 70.9 6.05 13.62 16.76 22.96 25.5 28.74 8.71 5.75 13.95 15.48 13.79 25.91l-2.94 195.78 517.46.49v-336.2c-237.73-.91-469.96-1.75-478.36-1.56Z"
          style={{
            fill: '#5874a9',
          }}
        />
        <path
          d="M722.44 507.96c17.37.38 33.97-1.18 59.65 15.94 22.95 15.3 27.27 45.11 15.81 70.9-6.05 13.62-16.76 22.96-25.5 28.74-8.71 5.75-13.95 15.48-13.79 25.91l2.94 195.78-517.46.49v-336.2c237.73-.91 469.96-1.75 478.36-1.56Z"
          style={{
            fill: '#5874a9',
          }}
        />
        <path
          d="M-51.95 673.88c8.55-.17 340.54-.2 348.58-.05 9.95.18 13.56 3.9 13.56 8.65 0 9.11.53 32.31.14 39.75-.22 4.18-4.23 6.93-11.35 6.93-12.3 0-342.27.41-352.44.41-10.16 0-12.2-3.43-12.2-8.84s.1-31.86.1-39.82c0-4.26 4.23-6.83 13.61-7.02Z"
          style={{
            fill: '#3e659e',
          }}
        />
        <path
          d="M-49.67 450.15c33.68-9.32 319.07-6.08 326.99-6.29 20-.53 29.77 14.51 29.69 24.65-.15 19.47-.77 166.48-1.28 182.39-.28 8.92-4.28 14.79-11.3 14.79-12.12 0-326.43.87-336.45.87-10.01 0-11.96-7.32-11.87-18.87.09-11.56-14.7-138.08-15.71-165.39-.34-9.1 11.01-29.68 19.93-32.14Zm719.74 0c-8.28-1.65-319.09-1.53-327.01-1.23-27.31 1.01-30.42 20.2-30.34 30.34.15 19.47 1.45 155.73 1.95 171.64.28 8.92 4.28 14.79 11.3 14.79 12.12 0 317.35.86 327.36.86 10.01 0 19.43-7.41 20.96-18.87S692.81 497.71 692 488.36c-2.02-23.26-5.25-34.88-21.93-38.21Z"
          style={{
            fill: '#3b6198',
          }}
        />
        <path
          d="M667.03 673.68c-8.55-.17-330.36.01-338.4.15-9.95.18-13.56 3.9-13.56 8.65 0 9.11-.53 32.31-.14 39.75.22 4.18 4.23 6.93 11.35 6.93 12.3 0 331.13 2.58 341.3 2.58s19.38-2.14 23.01-13.69c1.62-5.16-1.86-25.5-2.74-33.41-1.1-9.86-11.44-10.76-20.81-10.95Z"
          style={{
            fill: '#3e659e',
          }}
        />
        <path
          d="M228.1 132.7c64-.8 121.18 39.04 124 125.36 2.55 77.88-51.22 134.25-119.73 135.98s-124.52-45.76-126.4-134.1c-1.53-71.84 51.87-126.37 122.13-127.25Z"
          style={{
            fill: '#645e18',
          }}
        />
        <path
          d="M228.57 147.4c58.5 1.45 107.19 35.84 109.32 113.64 2.03 74.04-55.21 120.87-107.88 119.87-56.4-1.07-110.37-49.3-110.28-118.91.1-70.5 52.81-115.99 108.84-114.6Z"
          style={{
            fill: '#eee6f1',
          }}
        />
        <g
          style={{
            clipPath: 'url(#livingroom2-b)',
          }}
        >
          <path
            d="M285.26 50.89S208.11 236.96 178.61 307.3C149.11 377.64 106 488.83 106 488.83l238.26 11.35 90.76-392.56-149.76-56.73Z"
            style={{
              fill: 'none',
            }}
          />
          <path
            d="M426.1 199.02s-72.96-52.03-148.48-20.57c-71.73 29.89-66.69 75.55-116.3 93.39-64.48 23.18-124.18-33.45-193.95 35.95l99.94 204.99 375.51-265.37-16.72-48.39Z"
            style={{
              fill: '#f09b7d',
            }}
          />
          <path
            d="M561.25 221.58s-116.11-48.32-171.45 11.95c-83.94 91.41-189.93 0-287.28 96.82l99.94 204.99 375.49-265.37-16.72-48.39Z"
            style={{
              fill: '#f0c33d',
            }}
          />
        </g>
        <path
          d="M921.74 320.49c-1.15 0-1.94 1.18-1.55 2.27 5.49 15.14 40.07 110.57 49.44 138.4 10.75 31.93 32.72 70.31 33.75 85.55 1.3 19.22-20.91 29.37-25.52 41.97-11.04 30.19 3.76 59.91 3.76 59.91l9.55-.38s-8.19-35.09 6.33-55.35c14.52-20.25 49.58-32.81 68.13-46.82 20.48-15.47 45.86-45.48 44.33-45.48s-2.03-5.42-2.03-5.42-28.92 33.75-42.66 45.45c-11.85 10.09-66.84 33.85-66.84 33.85s14.6-13.17 12.69-27.31c-1.91-14.14-29.89-68.99-36.01-87.72C969 440.68 924 321.04 924 321.04s-2.27-.56-2.28-.56Z"
          style={{
            fill: '#0a8b30',
          }}
        />
        <path
          d="M936.63 327.66s0-35.79-27.29-45.63c-27.29-9.84-36.89-3.66-40.71.45-8.13 8.74-10.29 14.76-10.29 14.76s8.89-6.74 20.53-1.82c11.63 4.92 25.1 11.22 22.42 16.14-2.68 4.92-41.16-10.74-44.29-10.74s-10.74 5.82-14.76 12.97c-4.03 7.16-7.61 18.34-7.61 18.34s17.45-9.84 35.79-9.39c18.34.45 24.16 4.03 24.16 6.26s-26.39-1.79-40.26 3.13c-13.87 4.92-17.45 6.71-19.24 12.08-1.79 5.37-3.58 14.32-2.24 20.13 1.34 5.82 7.16 14.76 7.16 14.76s1.79-12.97 21.47-23.71 37.58-9.84 40.71-6.71c3.13 3.13-15.66 8.95-29.97 15.21-14.32 6.26-24.16 21.92-24.16 21.92l15.66 12.53s1.14-14.3 11.87-22.8c10.74-8.5 25.26-10.75 28.39-8.52 3.13 2.24-16.55 12.97-22.82 19.68-6.26 6.71-8.5 13.42-8.5 13.42s11.63 4.74 15.65 9.66c4.03 4.92 9.84 13.6 9.84 13.6s.25-8.99 10.09-15.7c9.84-6.71 31.58-8.78 31.58-8.78s11.31-6.74 10.03-20.9c-.88-9.78-17.25-20.83-10.99-23.51 6.26-2.68 15.21 8.5 17.45 17.89 2.24 9.39 2.42 20.43 2.42 20.43l28-15.95s-5.37-16.55-16.55-22.82c-11.18-6.26-20.13-10.29-18.79-12.97 1.34-2.68 17.45-4.47 27.74 7.61s6.26 18.79 6.26 18.79 12.53-9.39 16.55-18.34c4.03-8.95 3.58-15.66 3.58-15.66s-9.39-4.03-21.03-12.08c-11.63-8.05-21.92-9.84-28.63-5.82-6.71 4.03-19.24 12.08-19.24 12.08Zm-18.27 177.36s2.68-10.7-4.2-14.52c-6.88-3.82-11.08-3.44-17.96 1.53-6.88 4.97-10.32 23.31-19.11 30.95-8.79 7.64-17.96 17.2-17.2 26.75.76 9.55 4.66 18.67 4.66 18.67s4.15-6.92 9.5-8.63c11.85-3.81 42.79-17.68 51.19-24.94 8.41-7.26 25.57-23.16 13.76-33.63-6.78-6.01-20.64 3.82-20.64 3.82Zm87.26-46.95s.76-11.85-14.52-9.55c-15.29 2.29-26.75 16.43-18.73 30.19 8.03 13.76 15.72 18.63 17.63 22.45 1.91 3.82 3.86 5.79 3.86 5.79s1.99-2.15 5.67-4.9c5.74-4.31 33.82-17.04 35.73-31.56 1.91-14.52-8.63-17.77-15.89-18.92-7.26-1.15-13.76 6.5-13.76 6.5Z"
          style={{
            fill: '#0a8b30',
          }}
        />
        <path
          d="M903.92 516.48s24.69-9.17 44.68 10.83c20 20 49.79 82.38 49.79 82.38l8.13-1.57s-39.32-73.39-58.71-89.14c-19.39-15.76-44.31-7.85-44.31-7.85l.43 5.34Zm140.25-159.77s7.29-11.98 22.46-7.04c15.17 4.94 22.84 23.75 18.75 38.31-3.79 13.5-17.08 34.27-17.08 34.27s-1.37-15.52-5.4-25.37c-4.16-10.18-9.2-13.3-11.32-12.31-2.11.99 3.1 7.56 6.57 14.1 3.47 6.53 6.2 21.57 6.2 21.57s-10.94 2.34-18.42 5.59c-5.19 2.25-12.9 4.87-17.52 9.83-2.18 2.35-7.64 5.67-7.64 5.67s-4.11-9.81-7.8-18.57c-3.07-7.3-13.21-26.02-16.87-38.47s1.79-27.44 11.1-36.92c9.3-9.49 16.87-14.11 25.37-11.83 11.28 3.03 11.6 21.19 11.6 21.19Z"
          style={{
            fill: '#0a8b30',
          }}
        />
        <path
          d="M1041.55 362.64s1.42 69.74 9.88 101.79c8.46 32.05-17.59 59.86-23.38 93.69-5.79 33.83 2.01 92.83 2.01 92.83l-7.12-2.23s-7.25-60.76-3.69-89.25c3.56-28.49 35.74-66.11 27.73-95.04-8.01-28.93-10.68-101.49-10.68-101.49l5.26-.3Zm55.23 126.21s3.87-18.13 24.04-8.85c16.93 7.8 23 32.22 15.92 45.32-6.83 12.64-11.52 16.07-13.35 18.19-1.83 2.12-3.88 7.72-3.88 7.72s-2.64-3.19-9.22-6.24c-7.11-3.3-40.41-17.01-48.24-37.22-9.26-23.92 4.31-29.76 15.86-28.5 10.75 1.17 18.87 9.57 18.87 9.57Zm-90.77-17.17s-7.57 59.35-14.09 83.55c-6.81 25.26-8.12 47.1-10.84 61.76-3.26 17.6-6.8 32.93-6.8 32.93l6.67-.21s3.86-19.28 6.43-33.42 6.47-48.85 10.97-63.63c4.5-14.78 12.16-82.27 12.16-82.27l-4.5 1.29Z"
          style={{
            fill: '#0a8b30',
          }}
        />
        <path
          style={{
            fill: '#d0642d',
          }}
          d="m954.67 607.85 7.55 67.58h74.03l7.99-62.35 8.22-15.26 1.74-22.77-108.39.59.59 16.99 8.27 15.22z"
        />
        <path
          style={{
            fill: '#efe9e8',
          }}
          d="M1145.78 673.72v-11.18l-293.1 5.16v13.75l134.39-2.97 5.07 162.39-70.9 16.89-.72 10.07 175.41-1.58-.86-10.31-77.1-15.44.69-162.86 127.12-3.92z"
        />
        <path
          style={{
            fill: '#b39a4f',
          }}
          d="M1332.13 112.96h428.6v7.85h-428.6z"
        />
        <path
          style={{
            fill: '#f5f2ed',
          }}
          d="m1715.71 108.97-3.1 452.29h-335.29l-1.19-454.63 339.58 2.34z"
        />
        <path
          style={{
            fill: '#aacede',
          }}
          d="m1402.83 159.25 1.09 356.11 286.65-1.72 1.27-355-289.01.61z"
        />
        <path
          d="M1744.91 107.76c-6.46-.9-10.17 2.03-11.12 6.21-.99 4.38.41 9.78 6.47 11.24 6.17 1.49 11.79-2.5 12.17-7.13.35-4.42-1.06-9.41-7.52-10.32Zm-394.69-.22c-6.46-.9-10.17 2.03-11.12 6.21-.99 4.38.41 9.78 6.47 11.24 6.17 1.49 11.79-2.5 12.17-7.13.35-4.42-1.06-9.41-7.52-10.32Z"
          style={{
            fill: '#b39a4f',
          }}
        />
        <path
          style={{
            fill: '#f5f2ed',
          }}
          d="m1394.8 331.62 306.35-2.17-.72 11.59H1394.8v-9.42z"
        />
        <path
          style={{
            fill: '#f5f2ed',
          }}
          d="m1536.44 531.82-.44-420.2 11.58 1.07-1.72 419.13h-9.42z"
        />
        <path
          style={{
            fill: '#f2b85a',
          }}
          d="m1356.48 103.12.92 122.52 371.72-1.06-.16-122.1-372.48.64z"
        />
        <path
          style={{
            fill: '#d4c27f',
          }}
          d="m1360.22 549.12 367.32 2.62.5 13.92-367.31-1.37-.51-15.17z"
        />
      </g>
    </svg>
  )
}

export default LivingRoom2
